import { Collection } from 'modules/core/lib/mobx-rest'

import Result from 'modules/payroll_bundle/store/models/Result'

export class Results extends Collection<Result> {
  get cacheKey(): string {
    return 'results'
  }

  model() {
    return Result
  }

  get indexes(): string[] {
    return ['payroll_policy_period_id']
  }

  filterByPolicyPeriod(policyPeriodId: number): Result[] {
    return this.filter({
      payroll_policy_period_id: policyPeriodId,
    })
  }
}

const singleton: Results = new Results()

export default singleton
